import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();


export const getShiftSchedulingGlobalRulesService = async () => {
    try {
        return await http.get<any>(`/v1/shift-scheduling-global-rules`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getShiftSchedulingGlobalRulesService ', error);
    }
}

export const postShiftSchedulingGlobalRulesService = async (data: any) => {
    try {
        return await http.post<any>(`/v1/shift-scheduling-global-rules`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('postShiftSchedulingGlobalRulesService ', error);
    }
}

export const putShiftSchedulingGlobalRulesService = async (id: string, data: any) => {
    try {
        return await http.put<any>(`/v1/shift-scheduling-global-rules/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('putShiftSchedulingGlobalRulesService ', error);
    }
}
